// Nombre a mostrar del chofer. Fuente de verdad: el perfil de nuestra DB
// (firstName + lastName). Los fallbacks (name/email de Auth0) cubren el lapso
// hasta que el perfil carga, o el caso borde de un usuario sin perfil.

export interface DriverProfileName {
  firstName?: string | null;
  lastName?: string | null;
}

export function getDriverDisplayName(
  profile: DriverProfileName | null | undefined,
  ...fallbacks: (string | null | undefined)[]
): string {
  if (profile) {
    const fullName = [profile.firstName, profile.lastName]
      .map((part) => part?.trim() ?? "")
      .filter((part) => part.length > 0)
      .join(" ");
    if (fullName) return fullName;
  }

  for (const fallback of fallbacks) {
    if (fallback && fallback.trim()) return fallback;
  }

  return "Conductor";
}
